<template>
  <div class = "editor-sidemenu">
    <div class = "top-bar">
      <button v-on:click = "hideSideMenu" class = "btn btn-bg-transparent btn-left-icon">
        <span class="icon"><i class="mdi mdi-chevron-left"></i></span>
        Volver
      </button>
    </div>

    <ul class = "menu-section">
      <li v-if = "isAuthenticated"><a @click = "goTo('User')">Mis proyectos</a></li>
      <li v-else><a @click = "goTo('Editor.create')">Crear proyecto</a></li>

      <li v-if = "isInEditor || isInUser"><a @click = "toggleExamples">Ejemplos</a></li>
      <div v-if = "isShownExamples" class = "examples">
        <p>Se abrirán en una pestaña nueva</p>

        <div class = "group" v-for = "(ex, n) in examples" :key = "n">
          <p class = "dropdown-item header">{{n}}</p>
          <router-link
            v-for = "e in ex.examples"
            :key = "e"
            class = "dropdown-item"
            :to="{ name: 'Editor.example', params: { exampleType: n, exampleId: e.id }}"
            target="_blank">
            {{e.name}}
          </router-link>
        </div>
      </div>
    </ul>

    <ul class = "menu-section" v-if = "isInEditor || isInUser">
      <li v-on:click = "showSettings" v-if = "isInEditor"><a @click = "showSettings">Configurar este proyecto</a></li>
      <!-- <li class = "disabled">Configurar el Editor</li> -->
    </ul>

    <ul class = "menu-section">
      <li><a @click = "goTo('Gallery', { page: 1 })" target="_blank">Galería</a></li>
      <li><a @click = "goTo('Recursos')" target="_blank"> Recursos de Aprendizaje</a></li>
    </ul>

    <!--
    <ul class = "menu-section">
      <li class = "disabled">Salir de mi sesión</li>
    </ul>
    -->
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
  name: 'EditorSideMenu',
  props: {
  },
  data () {
    return {
      isShownExamples: false
    }
  },
  computed: {
    project () {
      return this.$store.state.project
    },
    examples: function () {
      return this.$store.state.examples
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    isInHome: function () {
      return this.$route.name === 'Home' || this.$route.name === 'Gallery' || this.$route.name === 'Recursos'
    },
    isInEditor: function () {
      return this.$route.name === 'Editor' || this.$route.name === 'Editor.create' || this.$route.name === 'Editor.created' || this.$route.name === 'Editor.example' || this.$route.name === 'Editor.load'
    },
    isInUser: function () {
      return this.$route.name === 'User'
    },
    isInUserSettings: function () {
      return this.$route.name === 'usersettings'
    }
  },
  methods: {
    goTo: function (where, params) {
      this.hideSideMenu()
      this.$router.push({ name: where, params: params })
    },
    createProject: function () {
      this.hideSideMenu()
      this.$router.push({ name: 'Editor.create' })
    },
    toggleExamples: function () {
      this.isShownExamples = !this.isShownExamples
    },
    showSettings: function () {
      this.hideSideMenu()
      this.$store.commit('setEditorConfigProperty', {'isShowingSettings': true})
    },
    hideSideMenu: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingSideMenu': false})
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.editor-sidemenu {
  background: @surfaceColor;
  color: @secondaryTextColor;
  position: absolute;
  height: 100vh;
  width: 100%;
  z-index: 10;
}

.top-bar {
  height: 58px;
  background: @accentColor;
  display: flex;
  align-items: center;

  .btn {
    height: 58px;
    padding: 18px;
    margin: 0;
  }
}

.examples {
  background: #0003;
  padding: 20px;
}

.menu-section {
  padding: 20px;
}

ul {
  p {
    padding: 5px;
    color: #fffb;
  }

  li {
    padding: 5px;
    border-bottom: 3px solid transparent;

    &:hover {
      cursor: pointer;
      color: @accentColor;
      margin-left: 2px;
      // border-color: @accentColor;
    }
  }
}

a {
  .font-code;
  color: white;
  font-size: 1.5em;

  &:hover {
    color: @accentColor;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorSideMenu.vue